import React, { Component } from 'react';
import gql from 'graphql-tag';
import { Mutation } from 'react-apollo';
import CommonCall from '../../fragments/call';

const START_CALL = gql`
  mutation StartCall($input: StartCallInput!) {
    startCall(input: $input) {
      ...CommonCall
    }
  }
  ${CommonCall}
`;

export default Comp => {
  /* eslint-disable react/prefer-stateless-function */
  class WithStartCallMutation extends Component {
    render() {
      return (
        <Mutation mutation={START_CALL} onError={() => undefined}>
          {(startCall, { data, loading, error }) => (
            <Comp
              {...this.props}
              onStartCall={startCall}
              startCallData={data}
              isLoadingStartCall={loading}
              startCallError={error}
            />
          )}
        </Mutation>
      );
    }
  }

  return WithStartCallMutation;
};
